import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";

import MasterEdit from "../../../components/master/MasterEdit";

const getBankOneAPI = `${process.env.REACT_APP_API_URL}api/bank`;

const MasterBankEdit = ({ buttonConfig, selectedItemId, isButtonClicked }) => {
  const schema = z.object({
    name: z.string().nonempty(),
    short_name: z.string(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };

  const form = useForm({
    defaultValues: async () => {
      const getSegment = `${getBankOneAPI}/${selectedItemId}`;
      const res = await axios.get(getSegment, { headers });
      const segment = res.data.data;
      return {
        name: segment.name,
        short_name: segment.short_name,
        status: segment.status ? "true" : "false",
        eff_start_date: segment.eff_start_date,
        eff_end_date: segment.eff_end_date,
      };
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterEdit
      form={form}
      segmentName={buttonConfig.name}
      editHandler={buttonConfig.editHandler}
      closeHandler={buttonConfig.closeEditModal}
      selectedItemId={selectedItemId}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterBankEdit;
